module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/042a4888fd5737d866bf70a7811f14b2.gif";